import * as React from 'react';
import { ChangeEvent, FormEvent } from 'react';
import { Alert } from '../../../../../components/Alert';
import { Heading } from '../../../../../components/Heading';
import { InfoText } from '../../../../../components/InfoText';
import { Button, TextField } from '@origin-digital/style-guide';
import { getForgotEmailUrl } from 'ts/login/services/urlService';
import { HorizontalRule } from 'ts/components/HorizontalRule';

interface EnterUsernameFormViewProps {
  username: string;
  onUsernameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onUsernameBlur: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: FormEvent<HTMLButtonElement>) => void;
  error: boolean;
  spinner: boolean;
  fieldNormalizer: (value: string, previousValue: string) => string;
  inlineErrorMessage: string;
  infoText: string;
}

const EnterUsernameFormView: React.FC<EnterUsernameFormViewProps> = ({
  username,
  onUsernameChange,
  onUsernameBlur,
  onSubmit,
  error,
  spinner,
  fieldNormalizer,
  inlineErrorMessage,
  infoText,
}) => {
  return (
    <form noValidate>
      {error && (
        <Alert
          text={
            `Sorry, we don't have this email in our system. Check it and try again, or ` +
            `[look up your email.](${getForgotEmailUrl()})`
          }
        />
      )}
      <Heading text="Step 1. Get your code" />
      <InfoText text={infoText} />
      <TextField
        type="email"
        label="Email address"
        name="username"
        disableIcon={!inlineErrorMessage}
        error={inlineErrorMessage}
        value={username}
        onBlur={onUsernameBlur}
        onChange={onUsernameChange}
        transform={fieldNormalizer}
      />
      <Button
        text="Get my code"
        type="submit"
        name="done"
        onClick={onSubmit}
        block={true}
        spinner={spinner}
      />
      <HorizontalRule />
    </form>
  );
};

export { EnterUsernameFormView };
